var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoiGen2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 47,
    viewBox: "0 0 35 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0361 33.1577C10.4161 33.1577 5.03613 34.9011 5.03613 37.0462C5.03613 38.3554 7.37613 39.4507 10.0961 40.2154C10.9561 40.4552 12.4561 40.8376 13.7961 41.4014C15.2761 42.03 16.6161 42.7041 17.0361 43.1577C17.4561 42.7041 18.7961 42.03 20.2761 41.4014C21.6161 40.8376 23.1161 40.4552 23.9761 40.2154C26.6961 39.4507 29.0361 38.3554 29.0361 37.0462C29.0361 34.9011 23.6561 33.1577 17.0361 33.1577Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1752 0C7.70021 0 0 7.70021 0 17.1752C0 22.9575 3.34916 27.7952 7.24221 31.173C8.47309 32.2321 10.62 33.921 12.5379 36.4114C14.6562 39.1881 16.5741 42.1651 17.1752 44.1689C17.7763 42.1651 19.6942 39.1881 21.8125 36.4114C23.7304 33.921 25.8773 32.2321 27.1082 31.173C31.0012 27.7952 34.3504 22.9575 34.3504 17.1752C34.3504 7.70021 26.6502 0 17.1752 0Z",
    fill: "#000000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 2.03613,
    y: 30.1577,
    width: 30,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiGen2);
export default __webpack_public_path__ + "static/media/poi-gen2.ab5e2145.svg";
export { ForwardRef as ReactComponent };